import * as React from "react";

import styles from "./header.module.scss";

import { ReactComponent as Tagline } from "./tagline.svg";
import { ReactComponent as NSWGovLogo } from "../../style/assets/nsw-gov-logo.svg";

const Header = (props: { goHome: () => void }) => {
    return (
        <div className={styles.header}>
            <Tagline
                onClick={props.goHome}
                className={styles.tagline}
                title="Know the Rules. You're responsible"
            />
            <NSWGovLogo className={styles.nswGovLogo} />
        </div>
    );
};

export default Header;
